<base-index-page
  [config]="baseIndexPageConfig"
  [service]="deleteService"
  [idKey]="'clientId'">

  <regulator-context-box [items]="contextItems" (back)="goBack()" />

</base-index-page>

<ng-template #clientModal>
  <form [formGroup]="form" (ngSubmit)="submitForm()">
    <div class="modal-header">
      <h5 class="modal-title">{{ editingClient ? 'Edit Client' : 'Create Client' }}</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="closeForm()"></button>
    </div>
    <div class="modal-body">
      <div class="mb-3">
        <input-field type="text" label="Code" placeholder="Code" [inputFormControl]="control('code')" />
      </div>
      <div class="mb-3">
        <input-field type="text" label="Name" placeholder="Name" [inputFormControl]="control('name')" />
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="closeForm()">Cancel</button>
      <button type="submit" class="btn btn-success" [disabled]="isSaving">Save</button>
    </div>
  </form>
</ng-template>
